import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

export default function PermissionError() {

  return (
    <Card className="w-[350px] mx-auto mt-10">
      <CardHeader>
        <CardTitle>Permission Denied</CardTitle>
      </CardHeader>
      <CardContent>
        You aren't an admin! If you believe this is a mistake, make sure you're logged in to the right account or contact another admin.
      </CardContent>
    </Card>
  );
}